import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import ConditionalWrapper from '@Components/Utilities/ConditionalWrapper';

const ContactInformation = (props) => {

    const sandhillsEastHeader = () => {
        return (
            <>
                <div><strong>Sandhills East Limited</strong></div>
                <div><TranslationText tKey='sandhills.tradepubwebsite.mvc.sandhillseastlimitedliabilitymessage' /></div>
                <div><TranslationText tKey='sandhills.tradepubwebsite.mvc.registeredaddresssandhillseast' /></div>
                <div><TranslationText tKey='sandhills.tradepubwebsite.mvc.companyregistrationnumbersandhillseast' /></div>
            </>
        );
    };

    const australianOfficeAddress = () => {
        return (
            <div className='contact-info__contact'>
                <div><strong>Sandhills Pacific Pty Ltd</strong></div>
                <div>A proprietary company registered in Australia</div>
                <div>Registered Address: 1/371 Macarthur Avenue</div>
                <div>Hamilton, QLD 4007, Australia</div>
                <div>Company No.: 159 460 572</div>
                <div>Business No.: 30 159 460 572</div>
                <div>GST: 30159460572</div>
            </div>
        );
    };

    const manchesterOfficeAddress = () => {
        return (
            <>
                <div>3rd Floor</div>
                <div>101 Princess Street</div>
                <div>Manchester - M1 6DD</div>
                <div>United Kingdom</div>
            </>
        );
    };

    const frenchLegalContactInfo = () => {
        return (
            <>
                <div><strong>Sandhills East Ltd, represented by its France Branch</strong></div>
                <div>A secondary establishment of a private limited company registered with the Trade and Companies register of Amiens</div>
                <div>Registered Address: 32 Allée de la Pépinière Centre Oasis Dury 80000 Amiens, France</div>
                <div>RCS Amiens: 828 131 508</div>
                <div>SIREN: 828 131 508</div>
                <div>SIRET: 828 131 508 00024</div>
                <div>Share Capital: €10,003.00</div>
                <div>VAT: FR78828131508</div>
                <div>Representative: Mr. Shawn Peed</div>
                <div>Web Host: Sandhills Publishing, 120 W. Harvest Dr., Lincoln, NE 68521, (402) 479-2181</div>
                <br />
                <div><strong>Sandhills East Ltd, Manchester Office</strong></div>
                {manchesterOfficeAddress()}
                <div>{props.EuropeanPhoneNumber}</div>
            </>
        );
    };

    const advertisingPhone = (phones) => {
        return (
            <div className='contact-info__contact'>
                <div><strong><TranslationText tKey='sandhills.tradepubwebsite.mvc.advertising' /></strong></div>
                {phones.map((phone) => <div>{phone}</div>)}
            </div>
        );
    };

    return (
        <div className='contact-us-information'>
            {props.IsNetherlands &&
                <div className='contact-info'>
                    <div className='contact-info__contact'>
                        <div><strong>Sandhills East Limited - Nederlandse vestiging</strong></div>
                        <div>Een besloten vennootschap geregistreerd bij het Nederlands Handelsregister</div>
                        <div>Geregistreerd Adres: Johan Cruijff Boulevard 65-71, 1101 DL Amsterdam, Nederland</div>
                        <div>CCI No.: 70661960</div>
                        <div>Oprichtingsnummer: 000038909057</div>
                        <div>BTW: NL825508460B01</div>
                    </div>

                    <div className='contact-info__contact'>
                        {sandhillsEastHeader()}
                </div>
                {advertisingPhone(props.IsTBSI ? [props.SitePhoneNumber, props.SiteSecondaryPhoneNumber] :[props.SitePhoneNumber])}
                </div>}
            {props.IsSpain &&
                <div className='contact-info'>
                    {props.IsCraneTrader &&
                        <div className='contact-info__contact'>
                            <div className='m-bottom-15'>
                    <div><strong>Dirección</strong></div>
                                <div>Parque Empresarial Las Mercedes</div>
                                <div>Edificio 4, Planta 3.</div>
                                <div>Avenida de Aragón 330</div>
                                <div>28022 Madrid, España</div>
                            </div>
                        </div>
                    }
                    <div className='contact-info__contact'>
                        <div><strong>Sandhills East Ltd Sucursal en Espana</strong></div>
                        <div>{translator.translate('Sandhills.TradeSites.MVC.APrivateLimitedCompany', ['Madrid'])}</div>
                        <div><TranslationText tKey='sandhills.tradepubwebsite.mvc.registered.address' />: C/Diego de León, 59 2º C, 28006 Madrid</div>
                        <div><TranslationText tKey='Sandhills.TradeSites.MVC.CompanyNo' />: 12072294</div>
                        <div>NIF: W82628571 </div>
                    </div>
                    <div className='contact-info__contact'>
                        {sandhillsEastHeader()}
                        <div>NIF: N8262740G</div>
                    </div>
                    {advertisingPhone(['+34 900 83 87 07'])}
                </div>
            }
            {props.IsItaly && 
                <div className='contact-info'>
                                <div className='contact-info__contact'>
            <div><strong>Sandhills East Limited</strong></div>
                                    <div>A limited liability company incorporated and registered in England and Wales Companies House
                                    Registered Address: 3rd Floor, 1 Ashley Road, Altrincham, Cheshire WA14 2DT, United Kingdom
                                    </div>
                                    <div>No.: 07768642</div>
                                </div>
                    {props.IsMachinery ? (
                                <div className='contact-info__contact'>
                                    <div><strong>Supporto per il Cliente</strong></div>
                                    <div>Telefono: +39 02 89352806</div>
                                    <div>E-Mail: info@machinerytrader.it</div>
                                    <br/> 
                                    <div><strong>Supporto Web</strong></div>
                                    <div>Telefono: +39 0861 1828850</div>
                                    <div>E-Mail: info@machinerytrader.it</div>
                                </div>)
                    : (<>
                        {advertisingPhone([props.SitePhoneNumber])}
                        </>)
                    }
                </div>
            }
            { props.UseGermanyInfo && 
                <div className='contact-info'>
                    <div className='contact-info__contact'>
                        <div><strong>Sandhills East Limited, Niederlassung Deutschland</strong></div>
                        <div>Eine Gesellschaft mit beschränkter Haftung, eingetragen im Handelsregister in Hamburg</div>
                        <div>Eingetragene Adresse: Hamburg Business Center im Hanseviertel, Poststr. 33, 20354 Hamburg, Deutschland</div>
                        <div>Deutschland</div>
                        <div>Registrierte Nummer: HRB 150302</div>
                        <div>UST-IdNr.: DE311563067</div>
                        <div>Gesetzlicher Vertreter: Hr. Shawn Peed, 120 West Harvest Drive, Lincoln, Nebraska, USA</div>
                    {(props.IsCraneTrader || props.IsTractorHouse) &&
                        <div>Journalist: Andreas Aepler</div>}
                        <div>Telefon: +49 (0)40 3018 7517</div>
                    </div>
                    <div className='contact-info__contact'>
                        <div><strong>Sandhills East Limited</strong></div>
                        <div>Eine Gesellschaft mit beschränkter Haftung, eingetragen im Handelsgericht England und Wales Companies House.</div>
                        <div>Eingetragene Adresse: 3rd Floor, 1 Ashley Road, Altrincham, Cheshire WA14 2DT, United Kingdom</div>
                        <div>No.: 07768642</div>
                    </div>
                    <div className='contact-info__contact'>
                        <div><strong>Allgemeine Kundenbetreuung</strong></div>
                    <div>Telefon: +49 (0)40 30187517</div>
                    {props.IsMachinery &&
                        <div>E-Mail: info@machinerytrader.de</div>}
                    </div>
                </div>}
            {props.IsEurope &&
                <div className='contact-info'>
                    <div className='contact-info__contact'>
                        <div><strong>Sandhills East Limited</strong></div>
                        <div>A limited liability company incorporated and registered in England and Wales Companies House</div>
                            <div><TranslationText tKey='sandhills.tradepubwebsite.mvc.registered.address' />: 3rd Floor, 1 Ashley Road, Altrincham,</div>
                        <div>Cheshire WA14 2DT,</div>
                        <div>United Kingdom</div>
                        <div>No.: 07768642</div>
                    </div>
                    <div className='contact-info__contact'>
                        <div><strong><TranslationText tKey='sandhills.tradepubwebsite.mvc.advertising' /></strong></div>
                        <div>Phone: +49 (0)40 30187517</div>
                        {props.IsMachinery &&
                            <div>E-Mail: info@machinerytrader.de</div>}
                        {props.IsTractorHouse && 
                            <div>E-Mail: info@tractor-house.de</div>}
                        {props.IsTBSI &&
                            <div>E-Mail: info@truck-mobiles.de</div>}
                    </div>
                </div>}
            {props.UseUKInfo &&
                <div className='contact-info'>
                    <div className='contact-info__contact'>
                        <div><strong><TranslationText tKey='sandhills.crm.dscrm.businessaddress' /></strong></div>
                        {manchesterOfficeAddress()}
                        <div>{props.ManchesterPhoneNumber}</div>
                    </div>
                    <div className='contact-info__contact'>
                        {sandhillsEastHeader()}
                        <div><TranslationText tKey='sandhills.tradepubwebsite.mvc.vatnumbersandhillseast' /></div>
                    </div>
                    {advertisingPhone(props.DisplayMainPhoneAndTollFree ?
                        [props.SitePhoneNumber, props.SiteTollFreePhoneNumber] : [props.SiteTollFreePhoneNumber != '' ? props.SiteTollFreePhoneNumber : props.SitePhoneNumber])}
                </div>}
            {props.UseAUInfo &&
                <div className='contact-info'>
                    <div className='contact-info__contact'>
                        <div><strong><TranslationText tKey='sandhills.tradepubwebsite.mvc.address' /></strong></div>
                        <div>P.O. Box 671 </div>
                        <div>Fortitude Valley, QLD 4006, Australia</div>
                        <div><em>Or</em></div>
                        <div>Level 1/371 Macarthur Avenue</div>
                        <div>Hamilton, QLD 4007, Australia</div>
                    </div>
                    {australianOfficeAddress()}
                    {advertisingPhone(props.IsIndia || (props.IsAsia && !props.IsTruckWorld) ? [props.SiteTollFreePhoneNumber] : [props.SiteTollFreePhoneNumber, props.PacificAltPhone])}
                </div>}
            {props.IsNewZealand &&
                <div className='contact-info'>
                    <div className='contact-info__contact'>
                        <div><strong>Sandhills Pacific Pty Ltd, represented by its New Zealand Branch</strong></div>
                        <div>Registered in New Zealand with the New Zealand Companies Office</div>
                        <div>Registered Address: Quigg Partners, Floor 7, 36 Brandon Street, Wellington Central, Wellington 6011, New Zealand</div>
                        <div>NZBN: 6580473</div>
                        <div>GST: 120-413-457</div>
                    </div>
                    {australianOfficeAddress()}
                    {advertisingPhone([props.SitePhoneNumber])}
                </div>}
            {props.UseSouthAfricaInfo &&
                <div className='contact-info'>
                    <div className='column4 left'>
                        <div><strong><TranslationText tKey='sandhills.crm.dscrm.businessaddress' /></strong></div>
                        <div>Office 143,</div>
                        <div>AMR Building 3,</div>
                        <div>Concorde Road East, Bedfordview</div>
                        <div>Johannesburg 2008</div>
                        <div>South Africa</div>
                    </div>
                    <div className='contact-info__contact'>
                        <div><strong>Sandhills South Africa PTY Ltd</strong></div>
                        <div>A proprietary company registered in the Republic of South Africa</div>
                        <div><TranslationText tKey='sandhills.tradepubwebsite.mvc.registered.address' />: 9 Kinross Street, Germiston South</div>
                        <div>Germiston, Gauteng, 1401 South Africa</div>
                        <div><TranslationText tKey='Sandhills.TradePubWebsite.MVC.CompanyRegistrationNumberSandhillsSouthAfrica' /></div>
                    </div>
                    {props.IsMarketBook ? advertisingPhone([props.SitePhoneNumber]) : advertisingPhone([props.SiteTollFreePhoneNumber])}
                </div>}
            {props.IsFrance &&
                <div className='contact-info'>
                    <div className='contact-info__contact'>
                        {frenchLegalContactInfo()}
                    </div>
                    <div className='contact-info__contact'>
                        {sandhillsEastHeader()}
                        <div>SIREN: 828 131 508</div>
                        <div>SIRET: 828 131 508 00016</div>
                        <div>Share Capital: £10,003.00</div>
                    </div>
                    {advertisingPhone([props.SitePhoneNumber])}
                </div>}
            {props.IsDefault &&
                <div className='contact-info'>
                    {!props.IsAviationTrader && !props.IsControllerEMEA &&
                    <div className='contact-info__contact narrow-column-spacing'>
                            <div className='m-bottom-15'>
                        <ConditionalWrapper condition={props.UseSEOHTagReorganization} wrapper={children => <h2 className="header-reset">{children}</h2>}>
                                    <div><strong>{(props.IsController || props.IsCharterHub) ? 'US Office' : <TranslationText tKey='sandhills.tradepubwebsite.mvc.address' />}</strong></div>
                            </ConditionalWrapper>
                                <div>P.O. Box 85670</div>
                                <div>Lincoln, NE 68501-5670</div>
                                {(props.IsController || props.IsCraneTrader || props.IsMarketBook || props.IsCharterHub) ?
                                    <div>
                                        <br />
                                        <div><TranslationText tKey='sandhills.tradepubwebsite.mvc.or' /></div>
                                        <br />
                                        <div><strong>Sandhills Global</strong></div>
                                    </div>
                                    : <div><strong>Or</strong></div>}
                                <div>120 W. Harvest Drive</div>
                                <div>Lincoln, NE 68521</div>
                                {(props.IsCraneTrader || props.IsMarketBook) && <div>USA</div> }
                            </div>
                        </div>}
                    {(props.IsController || props.IsAviationTrader || props.IsCharterHub) && !props.IsControllerEMEA &&
                    <div className='contact-info__contact narrow-column-spacing'>
                            <div className='m-bottom-15'>
                                <div><strong>Australia Office</strong></div>
                                <div>Sandhills Pacific</div>
                                <div>Level 1/371 Macarthur Avenue</div>
                                <div>Hamilton, QLD 4007, Australia</div>
                                <br />
                                <span><strong>Australia / Pacific Rim Enquiries</strong></span>
                                <div>{props.AustraliaPacificRimPhoneNumber}</div>
                                <br />
                            </div>
                        </div>}
                    {(props.IsController || props.IsCharterHub) &&
                    <div className='contact-info__contact narrow-column-spacing'>
                            <div className='m-bottom-15'>
                                <div><strong>European Office</strong></div>
                                {manchesterOfficeAddress()}
                                <br />
                                <span className='font16'><strong>Europe Enquiries</strong></span>
                                <div>{props.EuropeanPhoneNumber}</div>
                                <br />
                            </div>
                        </div>}
                    {props.IsControllerEMEA &&
                        <>
                        <div className='contact-info__contact narrow-column-spacing'>
                            <div className='m-bottom-15'>
                                <ConditionalWrapper condition={props.UseSEOHTagReorganization} wrapper={children => <h2 className="header-reset">{children}</h2>}>
                                    <div><strong>US Office</strong></div>
                                </ConditionalWrapper>
                                <div>P.O. Box 85670</div>
                                <div>Lincoln, NE 68501-5670</div>
                                    <div>
                                        <br />
                                        <div><TranslationText tKey='sandhills.tradepubwebsite.mvc.or' /></div>
                                        <br />
                                        <div><strong>Sandhills Global</strong></div>
                                    </div>
                                <div>120 W. Harvest Drive</div>
                                <div>Lincoln, NE 68521</div>
                            </div>
                        </div>
                        <div className='contact-info__contact narrow-column-spacing'>
                            <div className='m-bottom-15'>
                                <div><strong>Australia Office</strong></div>
                                <div>Sandhills Pacific</div>
                                <div>Level 1/371 Macarthur Avenue</div>
                                <div>Hamilton, QLD 4007, Australia</div>
                                <br />
                                <span><strong>Australia / Pacific Rim Enquiries</strong></span>
                                <div>{props.AustraliaPacificRimPhoneNumber}</div>
                                <br />
                            </div>
                        </div>
                    </>}
                    {!props.IsAviationTrader && !props.IsControllerEMEA &&
                    <div className='contact-info__contact narrow-column-spacing'>
                    <div className='m-bottom-15'>
                        <ConditionalWrapper condition={props.UseSEOHTagReorganization} wrapper={children => <h2 className= "header-reset">{children}</h2>}>
                                    <div><strong><TranslationText tKey='sandhills.tradepubwebsite.mvc.advertising' /></strong></div>
                        </ConditionalWrapper>
                                <div>{props.SiteTollFreePhoneNumber}</div>
                                {!props.IsBidCaller && props.SiteTollFreePhoneNumber !== props.SitePhoneNumber && <div>{props.SitePhoneNumber}</div>}
                                {(props.SiteFax != null && props.SiteFax !== '') && <div>Fax: {props.SiteFax}</div>}
                                {props.RegionSpecificPhoneNumbers &&
                                    Object.keys(props.RegionSpecificPhoneNumbers).map((key, index) =>
                                        <div key={index}>{key} : {props.RegionSpecificPhoneNumbers[key]}</div>
                                    )}
                            </div>
                        </div>}
                    {props.IncludeCirculationInfo &&
                    <div className='contact-info__contact narrow-column-spacing'>
                            <div className='m-bottom-15'>
                                <div><strong>Circulation</strong></div>
                                <div>{props.CirculationTollFreePhoneNumber}</div>
                                <div>{props.CirculationPhoneNumber}</div>
                                <div>Fax: {props.CirculationFaxNumber}</div>
                            </div>
                    </div>}
                {props.IncludeAuctionSupportInfo &&
                    <div className='contact-info__contact narrow-column-spacing'>
                            <div className='m-bottom-15'>
                                <div><strong>Auction Customer Support:</strong></div>
                                {!props.IsBidCaller ? (
                                    <>
                                        <div>{props.AuctionCustomerSupportTollFree}</div>
                                        <div>{props.AuctionCustomerSupportPhone}</div>
                                    </>
                                ) : (
                                    <div>{props.SiteTollFreePhoneNumber}</div>
                                )}                          
                        </div>
                    </div>}
                {props.IncludeFastTrackInfo &&
                    <div className='contact-info__contact narrow-column-spacing'>
                        <div className='m-bottom-15'>
                            <div><strong>Fast Track®</strong></div>
                            <div>{props.FastTrackTollFree}</div>
                        </div>
                    </div>}
                </div>}
        </div>
    );
};

export default ContactInformation;